<template>
  <div class="cash-sources-stat">
    <div class="stat-menu-abc">
      <v-container fluid>
        <stat-top-filter
          :filial-default="[globalFilialId]"
          last-month
          multiple-filial-select
          @applyFilter="applyFilter"
        >
          <template #afterApply="{ filter }">
            <v-btn
              style="border-radius: 10px"
              height="48px"
              depressed
              color="#D3D5D9"
              :loading="reportDownloading"
              @click="downloadReport(filter)"
            >
              Выгрузить в Excel
            </v-btn>
          </template>
        </stat-top-filter>

        <loader v-if="loading" />
        <template v-else>
          <div class="stat-menu-abc-table">
            <v-data-table
              v-if="statisticData.length"
              fixed-header
              :headers="headers"
              :page="page"
              :items="statisticData"
              :items-per-page="itemsPerPage"
              :sort-by="sortBy"
              :sort-desc="sortDesc"
              :footer-props="footerProps"
              :server-items-length="itemsLength"
              class="statistic-datatable headers-nowrap orange-header"
              @update:options="loadItems"
            >
              <template #item="{ item }">
                <tr>
                  <td>
                    <div class="user-column">
                      <avatar :user="item.user" class="mr-3" />
                      <div>{{ item.user.name }}</div>
                    </div>
                  </td>
                  <td class="text-center">
                    {{ formatCount(item.acceptedOrdersCount) }}
                  </td>
                  <td class="text-center">
                    {{ item.revenue | amountWithCurrency0 }}
                  </td>
                  <td class="text-center">
                    {{ item.upsellingRevenue | amountWithCurrency0 }}
                  </td>
                  <td class="text-center">
                    {{ item.upsellingRevenuePercentage }}%
                  </td>
                  <td class="text-center">
                    {{ item.avgBill | amountWithCurrency0 }}
                  </td>
                  <td class="text-center">
                    {{ formatAvgConfirmTime(item.avgConfirmTime) }}
                  </td>
                </tr>
              </template>
              <template v-if="statisticData.length" #body.append>
                <tr style="background-color: #fff3df">
                  <td class="text-center">
                    Итого:
                  </td>
                  <td class="text-center">
                    {{ formatCount(total.acceptedOrdersCount) }}
                  </td>
                  <td class="text-center">
                    {{ total.revenue | amountWithCurrency0 }}
                  </td>
                  <td class="text-center">
                    {{ total.upsellingRevenue | amountWithCurrency0 }}
                  </td>
                  <td class="text-center">
                    {{ total.upsellingRevenuePercentage }}%
                  </td>
                  <td class="text-center">
                    {{ total.avgBill | amountWithCurrency0 }}
                  </td>
                  <td class="text-center">
                    {{ formatAvgConfirmTime(total.avgConfirmTime) }}
                  </td>
                </tr>
              </template>
            </v-data-table>
            <div v-else class="no-data-label">
              Нет записей за выбранный период
            </div>
          </div>
        </template>
      </v-container>
    </div>
  </div>
</template>

<script>
  import Avatar from '@/components/administrator/work-shift/staff/Avatar'
  import StatTopFilter from '@/components/stat/StatTopFilter.vue'
  import Loader from '@/components/loader/Loader'
  import { mapGetters } from 'vuex'
  import SnackbarMessage from '@/mixins/snackbar-message'
  import permissions from '@/mixins/permissions'
  import callCenterEmployeesApi from '@/api/statistics/call-center/employees'
  import { getFileNameFromContentDispositionHeader } from '@/util/axios'
  import { formatNumberToThousandths } from '@/util/num-format'

  export default {
    name: 'EmployeesStatistics',
    components: {
      Loader,
      StatTopFilter,
      Avatar,
    },
    mixins: [permissions, SnackbarMessage],
    data () {
      return {
        indicators: {},
        loading: false,
        reportDownloading: false,
        footerProps: { 'items-per-page-options': [15, 25, 50, 100, -1] },
        startDate: null,
        endDate: null,
        filialIds: [],
        filialPreset: null,
        itemsLength: 0,
        itemsPerPage: 25,
        page: 1,
        sortBy: [],
        sortDesc: [],
        headers: [
          {
            text: 'Сотрудник',
            value: 'user',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Принято заказов',
            value: 'acceptedOrdersCount',
            align: 'center',
          },
          { text: 'Сумма', value: 'revenue', align: 'center' },
          { text: 'Допродажи', value: 'upsellingRevenue', align: 'center' },
          {
            text: '% Допродажи',
            value: 'upsellingRevenuePercentage',
            align: 'center',
            sortable: false,
          },
          { text: 'Средний ЧЕК', value: 'avgBill', align: 'center' },
          { text: 'СВП', value: 'avgConfirmTime', align: 'center' },
        ],
        statisticData: [],
        total: {
          acceptedOrdersCount: 0,
          revenue: 0,
          upsellingRevenue: 0,
          upsellingRevenuePercentage: 0,
          avgBill: 0,
          avgConfirmTime: 0,
        },
      }
    },
    computed: {
      ...mapGetters({
        globalFilialId: 'branches/getGlobalFilialId',
      }),
    },
    methods: {
      formatAvgConfirmTime (data) {
        let minutes = Math.floor(data / 60)
        minutes = minutes < 10 ? '0' + minutes : minutes
        let seconds = data % 60
        seconds = seconds < 10 ? '0' + seconds : seconds

        return `${minutes}:${seconds}`
      },
      formatCount (value) {
        return formatNumberToThousandths(value)
      },
      optionsChanged (options) {
        if (
          this.page !== options.page ||
          this.itemsPerPage !== options.itemsPerPage
        ) {
          return true
        }

        if (
          this.sortBy.length !== options.sortBy.length ||
          this.sortBy.some((item) => !options.sortBy.includes(item))
        ) {
          return true
        }

        return (
          this.sortDesc.length !== options.sortDesc.length ||
          this.sortDesc.some((item) => !options.sortDesc.includes(item))
        )
      },
      loadItems (data) {
        if (!this.optionsChanged(data)) {
          return
        }

        this.itemsPerPage = data.itemsPerPage
        this.page = data.page
        this.sortBy = data.sortBy
        this.sortDesc = data.sortDesc

        const payload = {
          from: this.startDate,
          to: this.endDate,
          filialIds: this.filialIds,
          filialPreset: this.filialPreset,
          page: data.page,
          limit: data.itemsPerPage,
          sortBy: data.sortBy,
          sortDesc: data.sortDesc,
        }

        this.fetchData(payload)
      },
      applyFilter (filter) {
        this.startDate = filter.from
        this.endDate = filter.to
        this.filialIds = filter.filialId
        this.filialPreset = filter.filialPreset

        const payload = {
          from: filter.from,
          to: filter.to,
          filialIds: filter.filialId,
          filialPreset: filter.filialPreset,
          page: this.page,
          limit: this.itemsPerPage,
          sortBy: this.sortBy,
          sortDesc: this.sortDesc,
        }

        this.fetchData(payload)
      },
      async fetchData (data) {
        this.loading = true
        this.statisticData = []

        try {
          const response = await callCenterEmployeesApi.fetchEmployeesStatistics(
            data,
          )
          this.statisticData = response.items
          this.itemsLength = response.meta.total
          this.itemsPerPage = response.meta.limit

          this.calcTotalData(response.items)
        } catch (e) {
          this.showErrorFromResponse(e)
        } finally {
          this.loading = false
        }
      },
      calcTotalData (items) {
        this.total.acceptedOrdersCount = items.reduce((acc, item) => {
          return item.acceptedOrdersCount + acc
        }, 0)
        this.total.revenue = items.reduce((acc, item) => {
          return item.revenue + acc
        }, 0)
        this.total.upsellingRevenue = items.reduce((acc, item) => {
          return item.upsellingRevenue + acc
        }, 0)
        this.total.upsellingRevenuePercentage = this.calcUpsellingRevenuePercentage(
          this.total.upsellingRevenue,
          this.total.revenue,
        )
        this.total.avgBill = this.calcAvgValue(items, 'avgBill')
        this.total.avgConfirmTime = this.calcAvgValue(items, 'avgConfirmTime')
      },
      calcUpsellingRevenuePercentage (upsellingRevenue, revenue) {
        if (!revenue) {
          return 0
        }

        return ((upsellingRevenue / revenue) * 100).toFixed(1)
      },
      calcAvgValue (items, key) {
        let sum = 0
        let count = 0

        items.forEach((item) => {
          if (item[key]) {
            sum += item[key]
            count++
          }
        })

        if (!count) {
          return 0
        }

        return (sum / count).toFixed(2)
      },
      async downloadReport (filter) {
        this.reportDownloading = true

        const payload = {
          from: filter.from,
          to: filter.to,
          filialIds: filter.filialId,
          filialPreset: filter.filialPreset,
        }

        try {
          const response = await callCenterEmployeesApi.exportEmployeesStatistics(
            payload,
          )
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(response.data)
          link.setAttribute(
            'download',
            getFileNameFromContentDispositionHeader(response),
          )
          document.body.appendChild(link)
          link.click()
          link.remove()
        } catch (err) {
          this.showErrorFromResponse(err)
        }

        this.reportDownloading = false
      },
    },
  }
</script>

<style lang="less" scoped>
@import 'src/assets/styles/statistic.less';

.statistic-datatable {
  ::v-deep {
    .v-data-footer {
      display: flex;
      margin-right: 0;
    }
  }
}

.user-column {
  display: inline-flex;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
